import { RequestDataSetting, updateSettingChat } from 'api/chat/setting/update-setting';
import { useSubscription } from 'hooks/use-subscription.hook';
import React, { useEffect, useRef, useState } from 'react';
import { colorAppearance } from '../list-sidebar';

interface IMessageProps {
  self: RequestDataSetting;
}

function Appearance({ self }: IMessageProps) {
  const subscription = useSubscription();
  const [checkIcon, setChechIcon] = useState<boolean>(true);
  const [checkNumber, setCheckNumber] = useState({ appearance: self.appearance, isCheckChangeContent: false });
  const colorRef = useRef(null);

  useEffect(() => {
    colorRef.current.querySelectorAll('.send').forEach((message) => {
      message.style.background = checkNumber.appearance;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleColor = (e, colorItem) => {
    setChechIcon(true);
    setCheckNumber({ appearance: colorItem, isCheckChangeContent: true });

    colorRef.current.querySelectorAll('.send').forEach((message) => {
      message.style.background = e.target.style.background;
    });
  };

  useEffect(() => {
    if (!checkNumber.isCheckChangeContent) return;

    const chatSettingSub = updateSettingChat(self._id, { appearance: checkNumber.appearance }).subscribe();

    subscription.add(chatSettingSub);
  }, [subscription, checkNumber, self._id]);

  return (
    <div className='appearance'>
      <h5>Preview</h5>
      <div className='text-item' ref={colorRef}>
        <p className='receive'>Checking out iOS7 you know..</p>
        <p className='send'>Check out this bubble!</p>
        <p className='receive'> pretty cool…</p>
        <p className='send'>Yeah pure CSS &amp; HTML</p>
      </div>
      <div>
        <h5 className='text-color'>Color</h5>
        <div className='block-item'>
          {colorAppearance.map((colorItem, idx) => (
            <div
              key={idx}
              className='item-color'
              style={{ background: colorItem }}
              onClick={(e) => handleColor(e, colorItem)}
            >
              {checkIcon && checkNumber.appearance === colorItem && (
                <div className='check-item'>
                  <i className='fas fa-check'></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Appearance;
